import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class ExtendTeamsToastMessage extends WebViewMessage {
  public windowHeight: number;
  public start: boolean;

  public constructor(windowHeight: number, start: boolean) {
    super(MessageType.ExtendTeamsToast);
    this.windowHeight = windowHeight;
    this.start = start;
  }
}
